import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/** Accent gradient (light → dark) cycled by season number. */
const ACCENTS: [string, string][] = [
    ['#ef4444', '#7f1d1d'], // red
    ['#3b82f6', '#1e3a8a'], // blue
    ['#10b981', '#064e3b'], // emerald
    ['#f59e0b', '#92400e'], // amber
    ['#8b5cf6', '#4c1d95'], // violet
    ['#14b8a6', '#134e4a'], // teal
];

/**
 * Participation badge (Teilnahmeabzeichen) for one league season: a shield
 * with checkered band, laurel branches and the season number. Rendered as an
 * inline SVG so the number and colors are dynamic.
 */
@Component({
    selector: 'app-season-badge',
    standalone: true,
    templateUrl: './seasonBadge.component.html',
    styleUrls: ['./seasonBadge.component.scss'],
    imports: [CommonModule],
})
export class SeasonBadgeComponent {
    @Input({ required: true }) seasonNumber = 0;

    /** 100% season: gold frame + glow + "100%" ribbon instead of the accent colour. */
    @Input() complete = false;

    // SVG defs need document-unique ids; several badges render on one page.
    private static nextUid = 0;
    readonly uid = ++SeasonBadgeComponent.nextUid;

    get accentLight(): string {
        return ACCENTS[(this.seasonNumber - 1 + ACCENTS.length * 100) % ACCENTS.length][0];
    }

    get accentDark(): string {
        return ACCENTS[(this.seasonNumber - 1 + ACCENTS.length * 100) % ACCENTS.length][1];
    }

    // 'Ethnocentric' is an extended (very wide) font; shrink for two digits.
    get numberFontSize(): number {
        return this.seasonNumber >= 10 ? 24 : 34;
    }

    get numberY(): number {
        return this.seasonNumber >= 10 ? 103 : 107;
    }
}
